
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-robot-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-semibold" style={{ fontFamily: '"Inter", sans-serif' }}>
                Ebusiness Marketing Group
              </span>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Empowering businesses with cutting‑edge AI Agency Services and comprehensive business development support.
              Transform your marketing with artificial intelligence and establish successful ventures with expert guidance.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-linkedin-fill text-xl"></i>
                </div>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-twitter-fill text-xl"></i>
                </div>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-facebook-fill text-xl"></i>
                </div>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <a href="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  AI Agency Services
                </a>
              </li>
              <li>
                <a href="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Business Development
                </a>
              </li>
              <li>
                <a href="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  DBA Establishment
                </a>
              </li>
              <li>
                <a href="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  AI Strategy Consulting
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <a href="/about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="/portfolio" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Portfolio
                </a>
              </li>
              <li>
                <a href="/contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  VistaBoost Imaging
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Ebusiness Marketing Group LLC. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <a
              href="https://readdy.ai/?origin=logo"
              className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
